export default __webpack_public_path__ + "static/media/Creamfinance FINRA Approved MM Advises Creamfinance on 21 million Equity Raise.433b9746.pdf";